// (function () {
//     function init(root) {
//       if (!root || root.dataset.aclReady) return;
//       root.dataset.aclReady = '1';

//       var slides = [].slice.call(root.querySelectorAll('.acl-hero__slide'));
//       var dots = [].slice.call(root.querySelectorAll('.acl-hero__dot'));
//       if (slides.length < 2) return;

//       var current = 0;
//       var timer = null;
//       var busy = false;
//       var speed = parseInt(root.dataset.speed, 10) || 5000;
//       var transMs = parseInt(root.dataset.trans, 10) || 1200;
//       var autoplay = root.dataset.autoplay === 'true';
//       var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

//       function show(n) {
//         n = (n + slides.length) % slides.length;
//         if (n === current || busy) return;
//         busy = true;

//         var out = slides[current];
//         var inc = slides[n];

//         slides.forEach(function (s) { s.classList.remove('is-prev'); });
//         out.classList.remove('is-active');
//         out.classList.add('is-prev');

//         void inc.offsetWidth;
//         inc.classList.add('is-active');

//         slides.forEach(function (s, i) {
//           var on = i === n;
//           if (on) s.removeAttribute('aria-hidden'); else s.setAttribute('aria-hidden', 'true');
//           var link = s.querySelector('.acl-hero__button');
//           if (link) link.tabIndex = on ? 0 : -1;
//         });
//         dots.forEach(function (d, i) {
//           d.classList.toggle('is-active', i === n);
//           if (i === n) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
//         });
//         current = n;

//         setTimeout(function () {
//           out.classList.remove('is-prev');
//           busy = false;
//         }, reduce ? 0 : transMs + 60);
//       }

//       function stop() { if (timer) { clearInterval(timer); timer = null; } }
//       function start() {
//         stop();
//         if (!autoplay || reduce) return;
//         timer = setInterval(function () {
//           if (!document.body.contains(root)) { stop(); return; }
//           show(current + 1);
//         }, speed);
//       }

//       dots.forEach(function (d, i) {
//         d.addEventListener('click', function () { show(i); start(); });
//       });

//       document.addEventListener('visibilitychange', function () {
//         if (document.hidden) stop(); else start();
//       });

//       /* theme editor: jump to the slide being edited */
//       root.addEventListener('shopify:block:select', function (e) {
//         var idx = slides.indexOf(e.target);
//         if (idx > -1) { autoplay = false; stop(); busy = false; show(idx); }
//       });

//       start();
//     }

//     function initAll() { document.querySelectorAll('[data-acl-hero]').forEach(init); }
//     if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
//     else initAll();
//     document.addEventListener('shopify:section:load', initAll);
//   })();

(function () {
function hydrate(slide) {
      if (!slide || slide.dataset.hydrated === '1') return;
       var template = slide.querySelector('template[data-acl-picture]');
      if (template && template.content) {
        template.replaceWith(template.content.cloneNode(true));
      }
      var picture = slide.querySelector('picture');
      if (!picture) return;
      picture.querySelectorAll('source[data-srcset]').forEach(function (source) {
        source.srcset = source.dataset.srcset;
        source.removeAttribute('data-srcset');
      });
      var img = picture.querySelector('img[data-src]');
      if (!img) {
        slide.dataset.hydrated = '1';
        return;
      }
      if (img.dataset.srcset) {
        img.srcset = img.dataset.srcset;
        img.removeAttribute('data-srcset');
      }
      img.src = img.dataset.src;
      img.removeAttribute('data-src');
      slide.dataset.hydrated = '1';
    }

  function init(root) {
    if (!root || root.dataset.aclReady) return;
    root.dataset.aclReady = '1';

    var slides = Array.from(root.querySelectorAll('.acl-hero__slide'));
    var dots = Array.from(root.querySelectorAll('.acl-hero__dot'));
    if (slides.length < 2) return;

    var current = 0;
    var timer = null;
    var busy = false;
    var speed = parseInt(root.dataset.speed, 10) || 5000;
    var transMs = parseInt(root.dataset.trans, 10) || 1200;
    var autoplay = root.dataset.autoplay === 'true';
    var reduce = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches;

    function stop() {
      clearTimeout(timer);
      timer = null;
    }

    function start() {
      stop();
      if (!autoplay || reduce || document.hidden || busy) return;

      timer = setTimeout(function () {
        if (!root.isConnected) return;
        show(current + 1);
      }, speed);
    }

    function loadSlide(slide) {
      // var template = slide.querySelector('template[data-acl-picture]');
      hydrate(slide);

      // if (template) {
      //   template.replaceWith(template.content.cloneNode(true));
      // }

      var img = slide.querySelector('img');
      if (!img) return Promise.resolve();

      return new Promise(function (resolve, reject) {
        function cleanup() {
          img.removeEventListener('load', loaded);
          img.removeEventListener('error', failed);
        }

        function loaded() {
          cleanup();
          if (img.decode) {
            img.decode().catch(function () {}).then(resolve);
          } else {
            resolve();
          }
        }

        function failed() {
          cleanup();
          reject(new Error('Hero image could not be loaded.'));
        }

        img.addEventListener('load', loaded);
        img.addEventListener('error', failed);

        if (img.complete) {
          if (img.naturalWidth) loaded();
          else failed();
        }
      });
    }

    async function show(n) {
      n = (n + slides.length) % slides.length;
      if (busy) return;
      if (n === current) {
        start();
        return;
      }

      stop();
      busy = true;
        hydrate(slides[n]);
        hydrate(slides[(n + 1) % slides.length]);

      var out = slides[current];
      var inc = slides[n];

      try {
        // Keep the current slide visible while the requested image loads.
        await loadSlide(inc);
        if (!root.isConnected) {
          busy = false;
          return;
        }

        slides.forEach(function (slide) {
          slide.classList.remove('is-prev');
        });

        out.classList.remove('is-active');
        out.classList.add('is-prev');

        void inc.offsetWidth;
        inc.classList.add('is-active');

        slides.forEach(function (slide, i) {
          var active = i === n;
          if (active) slide.removeAttribute('aria-hidden');
          else slide.setAttribute('aria-hidden', 'true');

          slide.querySelectorAll('a, button').forEach(function (control) {
            control.tabIndex = active ? 0 : -1;
          });
        });

        dots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === n);
          if (i === n) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });

        current = n;

        var instant = reduce ||
          window.matchMedia('(max-width: 749px)').matches;

        setTimeout(function () {
          out.classList.remove('is-prev');
          busy = false;
          start();
        }, instant ? 0 : transMs + 60);
      } catch (error) {
        // Do not transition to a blank slide if its image fails.
        busy = false;
        start();
      }
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        show(i);
      });
    });

    // Optional existing arrow markup can use these attributes.
    root.querySelectorAll('[data-acl-prev]').forEach(function (button) {
      button.addEventListener('click', function () {
        show(current - 1);
      });
    });

    root.querySelectorAll('[data-acl-next]').forEach(function (button) {
      button.addEventListener('click', function () {
        show(current + 1);
      });
    });

    var touchStart = null;
    var suppressClickUntil = 0;

    root.addEventListener('touchstart', function (event) {
      touchStart = event.touches.length === 1
        ? { x: event.touches[0].clientX, y: event.touches[0].clientY }
        : null;
    }, { passive: true });

    root.addEventListener('touchend', function (event) {
      if (!touchStart || !event.changedTouches.length) return;

      var dx = event.changedTouches[0].clientX - touchStart.x;
      var dy = event.changedTouches[0].clientY - touchStart.y;
      touchStart = null;

      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) {
        suppressClickUntil = Date.now() + 500;
        show(current + (dx < 0 ? 1 : -1));
      }
    }, { passive: true });

    root.addEventListener('touchcancel', function () {
      touchStart = null;
    }, { passive: true });

    root.addEventListener('click', function (event) {
      if (Date.now() < suppressClickUntil) {
        event.preventDefault();
        event.stopPropagation();
      }
    }, true);

    function onVisibilityChange() {
      if (!root.isConnected) {
        stop();
        document.removeEventListener('visibilitychange', onVisibilityChange);
        return;
      }
      if (document.hidden) stop();
      else start();
    }

    document.addEventListener('visibilitychange', onVisibilityChange);

    root.addEventListener('shopify:block:select', function (event) {
      var slide = event.target.closest('.acl-hero__slide');
      var index = slides.indexOf(slide);
      if (index < 0) return;

      autoplay = false;
      stop();
      show(index);
    });

    // Start the autoplay countdown after the first image is ready.
    loadSlide(slides[current]).then(start, start);
  }

  function initAll() {
    document.querySelectorAll('[data-acl-hero]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
